import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type { WorkPackageFilesCollection } from './workPackageFiles.types';

export const useWorkPackageFiles = () => {
  const workPackageFilesCollection: WorkPackageFilesCollection = useRxCollection(
    RxdbCollectionName.WORK_PACKAGE_FILES,
  );

  const [workPackageFilesInitialized, setWorkPackageFilesInitialized] = useState<boolean>(false);

  useEffect(() => {
    if (workPackageFilesCollection) {
      setWorkPackageFilesInitialized(true);
    }
  }, [workPackageFilesCollection]);

  return {
    workPackageFilesInitialized,
    workPackageFilesCollection,
  };
};

export default useWorkPackageFiles;
